// ModelCatalogContext.jsx
// Responsibility: serve the model catalog the selectors render from.
//
// Per CLAUDE.md rule #1 the web app reads the catalog from GET /v1/models at
// runtime (the same surface the SDK uses) — never from a baked-in copy. We
// start from STATIC_CATALOG (bundled models.json) for instant first paint,
// then fetch the live catalog and swap it in. On any fetch/auth failure we
// keep the static fallback, so the selectors always have a valid catalog.
import React, { createContext, useContext, useEffect, useState } from 'react';
import { models as modelsApi } from '../aridel-client';
import { STATIC_CATALOG, catalogFromApi } from '../model-catalog';

const ModelCatalogContext = createContext(STATIC_CATALOG);

export const ModelCatalogProvider = ({ children }) => {
    const [catalog, setCatalog] = useState(STATIC_CATALOG);

    useEffect(() => {
        let cancelled = false;
        modelsApi
            .list()
            .then((resp) => {
                if (cancelled) return;
                const live = catalogFromApi(resp?.data || []);
                if (live.allModels.length) setCatalog(live);
            })
            .catch((err) => {
                // Not signed in yet, offline, etc. — keep the static fallback.
                console.warn('ModelCatalog: live /v1/models fetch failed, using bundled catalog', err);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <ModelCatalogContext.Provider value={catalog}>
            {children}
        </ModelCatalogContext.Provider>
    );
};

export const useModelCatalog = () => useContext(ModelCatalogContext);
